import React, { Component, useState } from 'react';
import CustomImage from '../../components/custom-image';

const TransformationAndInnovation = () => {
  return (
    <div className="awards-content buttom-section">
      <div className="one-col">
        <h4>Transformation and Innovation</h4>
        <div className="table-wrapper">
          <div className="desktop-img">
            <CustomImage
              className="icon-arrow-up"
              imageName="transformation-innovation.png"
              alt="Transformation and Innovation"
              maxWidth="895"
            />
          </div>
          <div className="mobile-img">
            <div className="table-img">
              <CustomImage
                className="icon-arrow-up"
                imageName="transformation-innovation-mobile.png"
                alt="Transformation and Innovation"
                maxWidth="895"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransformationAndInnovation;
